import axios from "axios";


  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }


export const updateReportScore = ({
  token,
  reportId,
  points,
  time,
  roles
}) => {
  const isGuest = roles === "GUEST_USER";

  let reportUrl;
  let reportRequestData;

  if (isGuest) {
    reportUrl = process.env.REACT_APP_UPDATE_GUEST_REPORT_URL;
    reportRequestData = {
      reportId: reportId,
      points: Number(points),
      time: time
    };
  } else {
    reportUrl = `${process.env.REACT_APP_UPDATE_REPORT_URL}/${reportId}`;
    reportRequestData = {
      reportId: reportId,
      points: Number(points),
      time:time
    };
  }

  const headers = {
    "client-secret": process.env.REACT_APP_CLIENT_SECRET,
    "Content-Type": "application/json",
    "Idempotency-Key": uuidv4()
  };

  if (!isGuest) {
    headers.Authorization = `Bearer ${token}`;
  }

  console.log("Report Payload:", reportRequestData);

  return axios.put(reportUrl, reportRequestData, { headers });
};